















































import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { FuzzyDateSelectableDialogMixin } from "./mixins";
import { IDateFormatConfiguration } from "../../../../../domain/configuration/IConfiguration";
import { DateFormatter } from "../../../../../domain/system";
import DateSelector from "../../../../system/selectors/DateSelector.vue";
import FuzzyDateSelectButton from "./FuzzyDateSelectButton.vue";

interface IDirectButtonDefinable {
  label: string;
  value: Date | string | (() => Date) | (() => string);
  shouldSetLinkedDate: boolean;
}

interface IDirectButtonsDefinable {
  minWidth: string;
  buttons: IDirectButtonDefinable[];
}

@Component({
  components: {
    DateSelector,
    FuzzyDateSelectButton,
  }
})
export default class FuzzyDateSelectDialog extends Mixins(
  FuzzyDateSelectableDialogMixin
) {
  $refs!: {
    dateSelector: DateSelector;
  };

  get customClassName(): string {
    return this.dialogClass
      ? "fuzzy-date-select-dialog " + this.dialogClass
      : "fuzzy-date-select-dialog";
  }

  get formatConfiguration(): IDateFormatConfiguration {
    const configuration = this.$store.getters.configuration.behavior.document.entities.date.formats as IDateFormatConfiguration[];
    return configuration
      ? Enumerable.from(configuration).firstOrDefault(c => (c.format === this.condition.format) || ((c.format + c.dayOfWeekFormatPostfix) === this.condition.format))
      : null;
  }

  get directPhraseButtons(): IDirectButtonsDefinable[] {
    if (!this.condition.enableApproximateInput) {
      return [];
    }
    return [
      {
        minWidth: "55px",
        buttons: [
          {
            label: this.suppressBlanks(this.indeterminationAsString),
            value: this.indeterminationAsString,
            shouldSetLinkedDate: false,
          },
          {
            label: this.suppressBlanks(this.unknownAsString),
            value: this.unknownAsString,
            shouldSetLinkedDate: false,
          },
          {
            label: this.suppressBlanks(this.aroundSelectedYearAsString),
            value: this.aroundSelectedYearValueAsString,
            shouldSetLinkedDate: true,
          },
          {
            label: this.suppressBlanks(this.aroundSelectedMonthAsString),
            value: this.aroundSelectedMonthValueAsString,
            shouldSetLinkedDate: true,
          },
        ],
      },
      {
        minWidth: "90px",
        buttons: [
          {
            label: this.selectedYear + "年\r\n" + this.selectedMonth + "月上旬",
            value: this.earlySelectedMonthValueAsString,
            shouldSetLinkedDate: true,
          },
          {
            label: this.selectedYear + "年\r\n" + this.selectedMonth + "月中旬",
            value: this.middleSelectedMonthValueAsString,
            shouldSetLinkedDate: true,
          },
          {
            label: this.selectedYear + "年\r\n" + this.selectedMonth + "月下旬",
            value: this.lateSelectedMonthValueAsString,
            shouldSetLinkedDate: true,
          },
        ],
      },
    ];
  }

  get aroundSelectedYearAsString(): string {
    return this.selectedYear + " 年 頃";
  }

  get aroundSelectedMonthAsString(): string {
    return this.selectedMonthAsString + " 頃";
  }

  get earlySelectedMonthAsString(): string {
    return this.selectedMonthAsString + " 上旬";
  }

  get middleSelectedMonthAsString(): string {
    return this.selectedMonthAsString + " 中旬";
  }

  get lateSelectedMonthAsString(): string {
    return this.selectedMonthAsString + " 下旬";
  }

  get selectedMonthAsString(): string {
    return this.selectedYear + " 年 " + this.selectedMonth + " 月";
  }

  get aroundSelectedYearValueAsString(): string {
    return this.selectedYearValueAsString + " 頃";
  }

  get selectedYearValueAsString(): string {
    return this.formatConfiguration
      ? DateFormatter.format(this.selectedDate, this.formatConfiguration.yearFormat)
      : this.selectedYear.toString();
  }

  get aroundSelectedMonthValueAsString(): string {
    return this.selectedMonthValueAsString + " 頃";
  }

  get earlySelectedMonthValueAsString(): string {
    return this.selectedMonthValueAsString + " 上旬";
  }

  get middleSelectedMonthValueAsString(): string {
    return this.selectedMonthValueAsString + " 中旬";
  }

  get lateSelectedMonthValueAsString(): string {
    return this.selectedMonthValueAsString + " 下旬";
  }

  get selectedMonthValueAsString(): string {
    return this.formatConfiguration
      ? DateFormatter.format(this.selectedDate, this.formatConfiguration.yearMonthFormat)
      : this.selectedMonthAsString;
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean) {
    if (newValue) {
      this.$nextTick(() => {
        if (this.$refs.dateSelector) {
          this.$refs.dateSelector.setFocus();
        }
      });
    }
  }
}
